import React from 'react';
import { Tag } from 'antd';

import { BouncedEmailStatus } from '@totem/components/administration/bouncedEmails/types';

const STATUS_COLORS: Record<BouncedEmailStatus, string> = {
  Review: 'warning',
  'No Contacts': 'default',
  Resolved: 'success',
  Ignored: 'default',
};

type Props = {
  status: BouncedEmailStatus;
};

const BouncedEmailStatusTag = ({ status }: Props) => (
  <Tag color={STATUS_COLORS[status] ?? 'default'}>{status}</Tag>
);

export default BouncedEmailStatusTag;
